import React, { useEffect, useContext, useCallback } from 'react'
import Home from './Home'
import { connect } from 'react-redux';
import { selectLocationPermissionAsked } from 'store/app/reducer';
import { bindActionCreators } from 'redux';
import { locationAsked } from 'store/app/actions'
import { notification, Button } from 'antd';
import { LayoutContext } from 'components/MainLayout/LayoutContext'
import { useHistory } from 'react-router';
import routesConfig from 'routesConfig';
import { selectUserLoggedIn, selectUserRegistered, selectCanStartRide, selectRideStartMinimumCredit } from 'store/user/reducer';
import { GeolocationContext } from 'components/GeolocationContext';
import { selectServiceWorkerUpdated, selectServiceWorkerRegistration } from 'store/swupdater/reducer';
import { defaultAmount } from '../../constants';

const mapStateToProps = state => ({
    locationPermissionAsked: selectLocationPermissionAsked(state),
    rideStartMinimumCredit: selectRideStartMinimumCredit(state),
    userLoggedIn: selectUserLoggedIn(state),
    userRegistered: selectUserRegistered(state),
    canStartRide: selectCanStartRide(state),
    serviceWorkerUpdated: selectServiceWorkerUpdated(state),
    serviceWorkerRegistration: selectServiceWorkerRegistration(state),
})

function HomeContainer({
    locationPermissionAsked, locationAsked,
    userLoggedIn, userRegistered, canStartRide,
    serviceWorkerUpdated, serviceWorkerRegistration, rideStartMinimumCredit
}) {

    const [{ menuVisible }] = useContext(LayoutContext)
    const { getLocation } = useContext(GeolocationContext)
    const history = useHistory()

    const enableLocation = useCallback(() => {
        if (locationAsked) {
            locationAsked()
            if (getLocation) {
                getLocation()
            }
        }
    }, [getLocation, locationAsked])

    const onLogin = () => {
        notification.close("user-login")
        history.push(routesConfig.login)
    }

    const onRegister = () => {
        notification.close("user-register")
        history.push(routesConfig.register)
    }

    const onSubscribe = () => {
        notification.close("cant-start-ride")
        history.push(routesConfig.subscription)
    }

    const onCredit = () => {
        notification.close("cant-start-ride")
        history.push(routesConfig.Credit)
    }

    const onScan = () => {
        if (!userLoggedIn) {
            notification.open({
                key: "user-login",
                message: "ثبت‌ نام",
                description: "لطفا برای استفاده از خدمات رورو ثبت‌ نام کنید یا وارد حساب کاربری خود شوید",
                duration: 5,
                top: 55,
                btn: <Button size="middle" type="primary" onClick={onLogin}>ثبت‌نام | ورود</Button>,
            })
        } else if (!userRegistered) {
            notification.open({
                key: "user-register",
                message: "تکمیل ثبت‌نام",
                description: "لطفا برای استفاده از خدمات رورو اطلاعات کاربری خود را تکمیل کنید",
                duration: 5,
                top: 55,
                btn: <Button size="middle" type="primary" onClick={onRegister}>تکمیل اطلاعات</Button>,
            })
        } else if (!canStartRide) {
            notification.open({
                className: 'subscribe-notif',
                key: "cant-start-ride",
                message: "افزایش اعتبار",
              /*{description: `لطفا برای شروع سفر با رورو اعتبار خود را به میزان ${rideStartMinimumCredit} هزار تومان افزایش دهید`, },*/
                description: `لطفا برای شروع سفر با رورو اعتبار خود را به میزان ${defaultAmount.toLocaleString()} تومان افزایش دهید`,
                duration: null,
                top: 55,
                btn: <>
                    <Button size="small" className='mb-1' type="primary" onClick={onCredit}>افزایش
                        اعتبار</Button>
                </>,
            })
        } else {
            history.push(routesConfig.scan)
        }
    }

    function onGuide(e) {
        history.push(routesConfig.rideGuide)
    }

    useEffect(()=>{
        enableLocation()
    }, [enableLocation])
    
    useEffect(() => {
        if (menuVisible) {
            notification.close('enable-location')
            notification.close('user-login')
            notification.close('user-register')
        }
    }, [menuVisible])
    useEffect(() => {
        if (!locationPermissionAsked && !menuVisible) {
            notification.open({
                key: "enable-location",
                message: "دسترسی موقعیت مکانی",
                description: "برای استفاده از امکانات رورو نیاز است شما دسترسی به موقعیت مکانی را به رورو بدهید",
                duration: 0,
                top: 55,
                btn: <Button size="middle" type="primary" onClick={enableLocation}>فعالسازی</Button>,
            })
            return () => notification.close("enable-location")
        } else {
            notification.close("enable-location")
        }
    }, [enableLocation, locationPermissionAsked, menuVisible])


    const startUpdate = useCallback(() => {
        const registrationWaiting = serviceWorkerRegistration.waiting;
        if (registrationWaiting) {
            registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
            registrationWaiting.addEventListener('statechange', e => {
                if (e.target.state === 'activated') {
                    window.location.reload();
                }
            });
        }
    }, [serviceWorkerRegistration])

    useEffect(() => {
        if (serviceWorkerUpdated && serviceWorkerRegistration && !menuVisible) {
            notification.open({
                key: 'update-sw',
                message: 'نسخه جدید رورو',
                description: 'نسخه جدیدی از رورو آماده نصب می‌باشد',
                duration: 0,
                top: 55,
                btn: <Button size="middle" type="primary" onClick={startUpdate}>فعالسازی</Button>
            })
        } else {
            notification.close('update-sw')
        }
    }, [serviceWorkerUpdated, serviceWorkerRegistration, menuVisible, startUpdate])

    return <Home
        onScan={onScan}
        onGuide={onGuide}
    />
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        locationAsked,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer)
